export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8888/api/"
    : "https://directory-backend.seadoc.co/api/"; // "https://seadoc-dashboard-backend.herokuapp.com/api/";
export const ACCESS_TOKEN_NAME = "x-auth-token";
